import { Schedule } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

type ScheduleIdArg = Pick<Schedule, 'businessId'>;

@Pipe({ name: 'scheduleId', standalone: true })
export class ScheduleIdPipe implements PipeTransform {
  public transform(value: ScheduleIdArg): string {
    return value.businessId;
  }
}
